import { render, staticRenderFns } from "./LicensesInvoices.vue?vue&type=template&id=b033d3ee&scoped=true"
import script from "./LicensesInvoices.vue?vue&type=script&lang=js"
export * from "./LicensesInvoices.vue?vue&type=script&lang=js"
import style0 from "./LicensesInvoices.vue?vue&type=style&index=0&id=b033d3ee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b033d3ee",
  null
  
)

export default component.exports